import React from 'react';
import './Home.css';
function About() {
  return (
    <section id="about">
      <h2>About Me</h2>
      <p>Hello! I am <strong>Shaik Dehtaj</strong>, a passionate and driven computer science post graduate with a strong foundation in software development using Mern Stack and problem-solving. I have recently completed my degree from KL University, where I honed my skills in various programming languages and new technologies.</p>
      <p><b>Email</b>:shaikdehtaj786@gmail.com</p>
      <p><b>Phone</b>:+91 901038011*</p>
    </section>
  );
}

export default About;
